module.exports = __webpack_public_path__ + "static/assets/115f33d047926ca0faf9b338cd073001.svg";